import React from 'react'
import ReactDOM from 'react-dom'
import MainApp from './component/index';
import ReactGA from 'react-ga'
import { LocaleProvider } from 'antd'
import enUS from 'antd/es/locale-provider/en_US';
import './index.css'
import './loading.css'

ReactGA.initialize('UA-59687410-8')
ReactGA.pageview(window.location.pathname + window.location.search)

ReactDOM.render(
  <LocaleProvider locale={enUS}>
    <MainApp />
  </LocaleProvider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js